// Swipe-down-to-close progressive enhancement for the BB filter bottom-sheet.
// Attaches to .bb-filters__drawer-handle inside the filters-drawer dialog.
// Works alongside Horizon's native dialog-component — does not replace any
// of its behavior. If this script fails, dialog still closes via × / backdrop / Esc.

const SWIPE_CLOSE_THRESHOLD_RATIO = 0.3; // fraction of sheet height
const SWIPE_CLOSE_VELOCITY = 0.5;        // px/ms threshold when distance short

function attachBottomSheet(dialogEl) {
  const handle = dialogEl.querySelector('.bb-filters__drawer-handle');
  if (!handle) return;

  let startY = null;
  let startTime = 0;
  let currentY = 0;
  let sheetHeight = 0;
  let dragging = false;

  handle.style.cursor = 'grab';
  handle.style.touchAction = 'none';

  handle.addEventListener('pointerdown', (e) => {
    startY = e.clientY;
    startTime = performance.now();
    currentY = 0;
    sheetHeight = dialogEl.getBoundingClientRect().height;
    dragging = true;
    handle.setPointerCapture(e.pointerId);
    handle.style.cursor = 'grabbing';
    dialogEl.style.transition = 'none';
  });

  handle.addEventListener('pointermove', (e) => {
    if (!dragging) return;
    currentY = Math.max(0, e.clientY - startY);
    dialogEl.style.transform = `translateY(${currentY}px)`;
  });

  const finishDrag = (e) => {
    if (!dragging) return;
    dragging = false;
    handle.releasePointerCapture(e.pointerId);
    handle.style.cursor = 'grab';
    dialogEl.style.transition = '';

    const elapsed = performance.now() - startTime;
    const velocity = currentY / elapsed;
    const ratio = currentY / sheetHeight;

    if (ratio > SWIPE_CLOSE_THRESHOLD_RATIO || velocity > SWIPE_CLOSE_VELOCITY) {
      const dc = dialogEl.closest('dialog-component');
      if (dc && typeof dc.closeDialog === 'function') {
        dialogEl.style.transform = '';
        dc.closeDialog();
      }
    } else {
      dialogEl.style.transform = '';
    }
  };

  handle.addEventListener('pointerup', finishDrag);
  handle.addEventListener('pointercancel', finishDrag);
}

// The dialog is rendered but not interactive until dialog-component initializes.
// Wait for document idle, then attach.
document.addEventListener('DOMContentLoaded', () => {
  const dialog = document.querySelector('#filters-drawer dialog.bb-filters__drawer');
  if (dialog) {
    attachBottomSheet(dialog);
  }
});
